import { useEffect, useState } from "react";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import FaqSect from "./faqSect";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import FeatureList from "./serviceFeatureList";
import ServiceImageSection from "./servicesImageSection";
import Gallery from "./gallery";
import Testimonials from "./testimonials";
import homeBackground from "../assets/webp/homeBackground.webp";
import videoHome from "../assets/video/VideoHome.mp4";
import FirstFrame from "../assets/webp/first-frame.webp";
import { clearAll } from "../Redux/Slices/counterSlice";
import WhyChooseUs from "./whyChooseUs";
import {
  dryClean,
  DryCleanListData,
  faqsForCustomers,
  featureListData,
  tailoring,
  TailoringListData,
  washFold,
} from "../constants/homePageConstant";
import OnboardCards from "./OwnbaordCard";
import { AppDownloadSection } from "../component/AppDownloadBadges";

export default function HomePage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(clearAll());
  }, []);

  return (
    <div className="font-poppins h-[calc(100vh-80px)] mt-[80px] overflow-y-auto scrollbar-hide">
      <section
        id="home"
        className="relative w-full h-[calc(100vh-75px)] overflow-hidden bg-no-repeat bg-cover bg-top"
      >
        {/* Video as background */}
        <video
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          poster={FirstFrame}
          className="absolute top-0 left-0 w-full h-full object-cover"
          src={videoHome} // import or path to your video file here
        />

        {/* Semi-transparent overlay for better text readability */}
        <div className="absolute inset-0 bg-black/30 z-10" />

        {/* Content section */}
        <div className="relative z-20 flex flex-col justify-center items-start h-full pl-[8vw] md:pl-[12vw]">
          <h1 className="text-white font-bold text-[40px] md:text-[60px] leading-tight mb-2 drop-shadow-lg">
            Laundry Made Simple 
          </h1>
          <p className="text-white text-base md:text-lg max-w-xl mb-8 drop-shadow">
           Fast, reliable, and on-demand. Tydii brings your clean clothes right to your doorstep - because your time matters.
          </p>

          {/* CTA box */}
          <div className="flex items-center gap-2 bg-white rounded-full pr-1 pl-4 py-1 shadow-lg">
            <div className="text-left px-2">
              <div className="font-[600] text-[#1E1F21]">Pickup</div>
              <div className="text-sm text-[#50555C]">Tonight</div>
            </div>
            <div className="h-12 mx-2 w-px bg-gray-300 hidden sm:block" />
            <div className="text-left px-2">
              <div className="font-[600] text-[#1E1F21]">Where</div>
              <div className="text-sm text-[#50555C]">Add address</div>
            </div>
            <button
              onClick={() => navigate("/auth/account")}
              className="ml-10 h-14 w-14 flex justify-center items-center rounded-full bg-[#02537F] hover:bg-[#096597] transition-colors text-white"
            >
              <ArrowForwardOutlinedIcon className="w-10 h-3" />
            </button>
          </div>
        </div>
      </section>

      <div
        className="w-full h-[164px] flex justify-center items-center"
        style={{
          background:
            "linear-gradient(90deg, #02537F 0%, #0585CB 60%, #035885 100%)",
        }}
      >
        <p className="text-white text-center text-lg md:text-xl max-w-4xl font-normal">
          <span className="font-bold">TYDII</span> provides{" "}
          <span className="italic font-semibold">
            All types of Laundry Services
          </span>{" "}
          to revolutionize training, certification, and education. Enhance your
          skills and credentials with our advanced solutions.
        </p>
      </div>
      <div id="features" className="mx-4 md:mx-6 lg:mx-14">
        <div className="flex flex-col md:flex-row items-center  justify-between mx-auto px-4 md:px-6 py-8 md:py-16 gap-10 lg:gap-16">
          <ServiceImageSection {...washFold} />
          <div className="hidden md:block w-full md:w-1/2">  <FeatureList features={featureListData} /> </div>
        </div>
      </div>

      <div className="mx-4 md:mx-6 lg:mx-14">
        <div className="flex flex-col md:flex-row items-center bg-[#F6FCFF] rounded-tl-[30px] rounded-br-[30px]  justify-between mx-auto px-4 md:px-6 py-8 md:py-16 gap-10 lg:gap-16">
          <div className="hidden md:block w-full md:w-1/2"><FeatureList features={DryCleanListData} /></div>
          <ServiceImageSection {...dryClean} />
          <div className="block md:hidden w-full md:w-1/2"><FeatureList features={featureListData} /></div>


        </div>
      </div>

      <div className="mx-4 md:mx-6 lg:mx-14">
        <div className="flex flex-col md:flex-row items-center  justify-between mx-auto px-4 md:px-6 py-8 md:py-16 gap-10 lg:gap-16">
          <ServiceImageSection {...tailoring} />
          <div className="hidden md:block w-full md:w-1/2"><FeatureList features={TailoringListData} /></div>
        </div>
      </div>
      {/*
       <div className="mx-4 md:mx-6 lg:mx-14">
        <div
          className="flex w-full justify-center items-center flex-col text-center h-[180px] md:h-[200px] lg:h-[230px] gap-2 md:gap-3 lg:gap-4 "
          style={{
            backgroundImage: `url(${homeBackground})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <p className="text-[#50555C] font-[700] text-base md:text-lg  lg:text-xl">
            Schedule today to
          </p>
          <h2 className="text-lg xs:text-xl md:text-[30px] lg:text-[40px] font-extrabold text-[#023B64] mb-3">
            Get $20 off your first order
          </h2>
          <button
            type="button"
            className="inline-flex items-center justify-center rounded-lg  text-[#FFFFFF] bg-[#02537F] hover:bg-sky-800 px-5 py-2.5 text-base font-bold shadow-sm transition"
          >
            Schedule your first pickup
          </button>
        </div>
      </div>
      */}

      <div className="bg-gradient-to-b from-white to-[#E3F8FF]">
        <div className="mx-4 md:mx-6 lg:mx-14 py-5 md:py-8">
          <Testimonials />
        </div>
      </div>

      <div className="mx-4 md:mx-6 lg:mx-14 py-6 md:py-12">
        <Gallery />
      </div>
      <OnboardCards />
      <AppDownloadSection audience="customer" />
      <div id="why-choose-us" className="mx-4 md:mx-6 lg:mx-14 py-6 md:py-12">
        <WhyChooseUs />
      </div>
      <div id="faq" className="bg-gradient-to-b from-[#F3FBFF] to-[#EEF9FF] ">
        <div className="mx-4 md:mx-6 lg:mx-14 py-6 md:py-12 ">
          <FaqSect faq={faqsForCustomers} />
        </div>
      </div>
      <div className="bg-[#034F78]">
        {" "}
        <Footer />
      </div>
    </div>
  );
}
